import { useState } from 'react';
import { ShoppingBag, Settings, LogOut, ChevronDown } from 'lucide-react';
import Link from 'next/link';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative ml-8">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center bg-yellow-500 text-white py-2 px-4 rounded-full shadow-lg"
      >
        09162336970
        <ChevronDown className="w-4 h-4 ml-2" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-50">
          <ul className="text-gray-700">
            <li>
              <Link
                href="/orders"
                className="flex items-center gap-2 p-3 hover:bg-gray-100 rounded-t-lg"
              >
                <ShoppingBag className="w-5 h-5" />
                سفارشات من
              </Link>
            </li>
            <li>
              <Link
                href="/profile"
                className="flex items-center gap-2 p-3 hover:bg-gray-100"
              >
                <Settings className="w-5 h-5" />
                اطلاعات کاربری
              </Link>
            </li>
            <li>
              <button
                onClick={() => console.log('خروج انجام شد')}
                className="flex items-center gap-2 p-3 hover:bg-gray-100 w-full text-right rounded-b-lg"
              >
                <LogOut className="w-5 h-5" />
                خروج از حساب
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
